export const AutoCompleteSizes = {
    Small: 'small',
    Medium: 'medium',
    Large: 'large',
    XLarge: 'xlarge',
};

export const SizesToTagsLimit = {
    [AutoCompleteSizes.Small]: 1,
    [AutoCompleteSizes.Medium]: 2,
    [AutoCompleteSizes.Large]: 3,
    [AutoCompleteSizes.XLarge]: 4,
};

export const SELECT_ALL = 'STATIC.BUTTONS.SELECT_ALL';
export const SELECTED = 'STATIC.AUTOCOMPLETE.SELECTED';
export const NO_SEARCH_RESULTS = 'STATIC.AUTOCOMPLETE.NO_SEARCH_RESULTS';
export const CLEAR_TEXT = 'STATIC.BUTTONS.CLEAR';
export const CATEGORY_ALL = 'all';
